import * as React from "react";
import { SVGProps } from "../types";

const DirectDebitIcon = (props: SVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="32"
    height="32"
    fill="none"
    viewBox="0 0 32 32"
    {...props}
  >
    <circle cx="16" cy="16" r="14" fill="#231F20"></circle>
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M16.542 13.909v8.578s-4.89-.898-4.89-4.307c0-2.72 3.62-3.92 4.89-4.271m0-.161c-2.939-.216-9.601 1.186-9.601 4.252 0 2 3.528 4.923 9.274 5 .226 0 6.754-.256 6.653-7.385-.084-5.986-4.489-7.035-5.898-7.218v-.365C22.585 8.394 27 11.832 27 16 27 20.41 22.06 24 15.987 24S5 20.41 5 16s4.914-8 10.987-8q.28 0 .555.01z"
      clipRule="evenodd"
    ></path>
  </svg>
);

export { DirectDebitIcon };
